<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <span class="sa-flexbox-body-title">Fatturazione</span>
                    <b-button size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" @click="onClickNuovaRichiesta" class="mb-2">
                        <font-awesome-icon icon="plus"> </font-awesome-icon>
                        Aggiungi
                    </b-button>
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template #cell(index)="row">
                            {{ (currentPage - 1) * perPage + row.index + 1 }}
                        </template>
                        <template #cell(meseAnnoRiferimento)="{ item }">
                            {{ formatDateTimeCustom(item.meseAnnoRiferimento, "MMM-yyyy") }}
                        </template>
                        <template #cell(createDate)="{ item }">
                            {{ formatDateTime(item.createDate) }}
                        </template>
                        <template v-slot:cell(actions)="row">
                            <b-container class="bv-example-row">
                                <b-button size="sm" v-b-tooltip.hover title="Visualizza Dettagli" variant="outline-secondary" @click="onClickView(row.item)" class="mr-1 no-text">
                                    <font-awesome-icon icon="eye" />
                                </b-button>
                            </b-container>
                        </template>
                    </b-table>
                </div>
            </div>
            <div class="d-flex flex-column">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>Records Totali: {{ rows }}</p>
                    </b-col>

                    <b-col lg="9">
                        <b-pagination :total-rows="rows" v-model="currentPage" :per-page="perPage" align="right" size="sm"> </b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
        <rsa-fatturazione-modal-edit-component ref="RsaFatturazioneModalEditComponent" @afterSave="onAfterSave"></rsa-fatturazione-modal-edit-component>
    </div>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaFatturazioneModalEditComponent from "./RsaFatturazioneModalEditComponent.vue";

export default {
    mixins: [UtilityMixin],
    components: { RsaFatturazioneModalEditComponent },
    data() {
        return {
            items: [],
            rows: 0,
            storicoMode: false,
            perPage: 50,
            idLetto: null,
            currentPage: 1,
            filtro: {},
            pathResource: "/rsafatturazionerichieste",
            endpoint: null,
            listKey: 0,
            fields: [
                {
                    label: "*",
                    key: "index",
                    thStyle: "width: 3rem",
                },
                {
                    label: "Struttura",
                    key: "presidio",
                    sortable: true,
                },
                {
                    label: "Setting",
                    key: "setting",
                    sortable: true,
                },
                {
                    label: "Mese Anno Riferimento",
                    key: "meseAnnoRiferimento",
                    sortable: true,
                    thStyle: "width: 18rem",
                },
                {
                    label: "Data Ora",
                    key: "createDate",
                    sortable: true,
                    thStyle: "width: 18rem",
                },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
        };
    },
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    methods: {
        onClickView(item) {
            // console.log(item);
            let me = this;
            me.$router.push("/rsafatturazione/dettagli?idRichiesta=" + item.id);
        },
        onClickNuovaRichiesta() {
            let me = this;
            me.$refs.RsaFatturazioneModalEditComponent.show();
        },
        loadData() {
            let me = this;
            me.filtro.page = me.currentPage;
            me.filtro.forPage = me.perPage;
            UtilityMixin.methods.loadDataResources(me.pathResource, me.filtro, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.$emit("afterLoadData");
            me.rows = response.data.data.recordsNumber;
            me.listKey++;
        },
        loadDataError(response) {
            let me = this;
            me.$emit("afterLoadData", response);
            me.$bvToast.toast("Errore durante il caricamento", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        onAfterSave() {
            let me = this;
            me.loadData();
        },
    },
};
</script>

<style></style>
